import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import MuiFormControlLabel from '@mui/material/FormControlLabel';
import MuiRadio from '@mui/material/Radio';
import { forwardRef } from 'react';
import { createSvgIcon, styled } from '../../utils';
import { WithEndDecorator, } from '../WithEndDecorator';
export const Radio = forwardRef(function Radio(props, ref) {
    const { error, label, required, endDecorator, emptyEndDecorator, color = 'primary', labelClass, size = 'small', ...otherProps } = props;
    return (_jsx(WithEndDecorator, { emptyEndDecorator: emptyEndDecorator, endDecorator: endDecorator, decoratorComponent: _jsx(LabelStyled, { error: error, className: labelClass, control: _jsx(RadioStyled, { inputRef: ref, color: color, error: error, icon: _jsx(RadioBase, {}), disableRipple: true, size: size, checkedIcon: _jsx(RadioSelected, {}), ...otherProps }), label: label && (_jsxs(_Fragment, { children: [label, required && '\xa0*'] })) }) }));
});
const RadioBase = createSvgIcon(_jsx("g", { id: "Icon_Radio_default", "data-name": "Icon/Radio/default", clipPath: "url(#clip-Icon_Radio_default)", children: _jsx("g", { id: "radio_default", "data-name": "radio/default", children: _jsxs("g", { id: "radio_default-2", "data-name": "radio/default", fill: "none", children: [_jsx("circle", { cx: "12", cy: "12", r: "12", stroke: "none" }), _jsx("circle", { cx: "12", cy: "12", r: "11.5", fill: "none" })] }) }) }), 'RadioBase');
const RadioSelected = createSvgIcon(_jsx("g", { id: "Icon_Radio_selected", "data-name": "Icon/Radio/selected", clipPath: "url(#clip-Icon_Radio_selected)", children: _jsxs("g", { id: "radio_selected", "data-name": "radio/selected", children: [_jsxs("g", { id: "Ellipse_494", children: [_jsx("circle", { cx: "12", cy: "12", r: "12", stroke: "none" }), _jsx("circle", { cx: "12", cy: "12", r: "11.5", fill: "none" })] }), _jsx("circle", { id: "Ellipse_495", "data-name": "Ellipse 495", cx: "6", cy: "6", r: "6", transform: "translate(6 6)", stroke: "none", fill: "#fff" })] }) }), 'RadioSelected');
const LabelStyled = styled(MuiFormControlLabel, {
    shouldForwardProp: (prop) => prop !== 'error',
})(({ theme, error }) => ({
    padding: 0,
    ...(!error && {
        '&:not(.Mui-disabled):hover .MuiRadio-root': {
            color: theme.palette.primary.main,
        },
    }),
    marginLeft: 0,
    '& .MuiFormControlLabel-label': {
        color: error ? theme.palette.error.main : 'inherit',
        width: '100%',
    },
}));
const RadioStyled = styled(MuiRadio, {
    shouldForwardProp: (prop) => prop !== 'error',
})(({ theme, error }) => ({
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(0.5),
    marginRight: theme.spacing(1),
    stroke: theme.palette.primary.dark,
    color: theme.palette.primary.dark,
    '&:hover': {
        color: 'theme.palette.primary.lighter',
        // TODO: remove stroke property when using a singlepath icon
        stroke: theme.palette.primary.lighter,
        backgroundColor: 'transparent',
    },
    '&.Mui-checked': {
        color: theme.palette.primary.dark,
        // TODO: remove stroke property when using a singlepath icon
        stroke: 'inherit',
        '&.Mui-disabled': {
            stroke: 'inherit',
            color: theme.palette.secondary.light,
        },
        '&:hover': {
            color: theme.palette.primary.light,
            stroke: theme.palette.primary.light,
        },
    },
    '&.Mui-disabled': {
        color: theme.palette.secondary.light,
        // TODO: remove stroke property when using a singlepath icon
        stroke: theme.palette.secondary.light,
    },
    ...(error && {
        stroke: theme.palette.error.main,
        color: theme.palette.error.main,
        '&.Mui-checked': {
            color: theme.palette.error.main,
            // TODO: remove stroke property when using a singlepath icon
            stroke: 'inherit',
            '&:hover': {
                color: theme.palette.error.light,
                // TODO: remove stroke property when using a singlepath icon
                stroke: 'inherit',
            },
        },
        '&:hover': {
            color: theme.palette.error.light,
            // TODO: remove stroke property when using a singlepath icon
            stroke: theme.palette.error.light,
        },
    }),
}));
